/** @jsx jsx */
import { jsx, css, Global } from '@emotion/react';
import React, { useEffect } from 'react';
import i18n from '@/utils/i18n';
import { useTranslation } from 'react-i18next';
import { LangKey as awxLangKey } from '@airwallex/global';
import { ThemeProvider } from '@airwallex/theme';
import { getLanguage } from '@/utils/language';
import { StoreProvider } from '@/providers/storeProvider';
import Route from './pages';
import { airTracker } from './utils/airTracker';
import { useExperiment, useFeatureGate } from '@statsig/react-bindings';
import { StoreProviderV2 } from './pages/paybylinkV2/providers/storeProvider';
import StatsigProviderV2 from './pages/paybylinkV2/providers/statsigProvider';
import { ToastProvider } from '@airwallex/toast';
import { getPageEnvByHost } from './utils/environment';
import { clientGetStorage, StorageKey } from './utils/localStorage';

export const COMPONENT_NAME_V2 = 'PBL_FE_V2';

const App: React.FC = () => {
  useEffect(() => {
    const langKey = getLanguage();
    airTracker.updateCommonData({ lang: langKey });
    i18n.changeLanguage(langKey);
  }, []);
  return (
    <StatsigProviderV2>
      <AppWrapper />
    </StatsigProviderV2>
  );
};

const AppWrapper = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const env = getPageEnvByHost();
  const enableOnePageCheckout = clientGetStorage(StorageKey.ONE_PAGE_CHECKOUT) === 'true';
  const enablePblFeV2FF = useFeatureGate('enable-pbl-fe-v2').value;
  const experiment = useExperiment('payment_link_ab_test');
  const enablePblFeV2 = experiment.get('enable-pbl-v2') as boolean;
  return (enablePblFeV2FF && env === 'staging') || enablePblFeV2 || enableOnePageCheckout ? (
    <React.Fragment>
      <ThemeProvider langKey={language as awxLangKey}>
        <StoreProvider>
          <StoreProviderV2>
            <Global
              styles={css`
                input {
                  font-family: AxLLCircular, Helvetica, Arial, sans-serif;
                }
                @font-face {
                  font-family: AxLLCircular;
                  src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2);
                  font-weight: 400;
                  font-style: normal;
                }
                @font-face {
                  font-family: AxLLCircular;
                  src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXSub-BoldSubset.woff2);
                  font-weight: 500;
                  font-style: normal;
                }
              `}
            />
            <ToastProvider container={document.body}>
              <Route />
            </ToastProvider>
          </StoreProviderV2>
        </StoreProvider>
      </ThemeProvider>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <ThemeProvider langKey={language as awxLangKey}>
        <StoreProvider>
          <Global
            styles={css`
              input {
                font-family: AxLLCircular, Helvetica, Arial, sans-serif;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2);
                font-weight: 400;
                font-style: normal;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXSub-BoldSubset.woff2);
                font-weight: 500;
                font-style: normal;
              }
            `}
          />
          <Route />
        </StoreProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};
export default App;
